var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "meta-leads-channel-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [{ title: "Meta Leads Channel Detail" }],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "IconButton",
                    {
                      attrs: {
                        "on-click": function () {
                          return _vm.$router.push("/integrations/meta-leads")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" chevron_left "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [_c("MetaIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.metaLeadsChannel")) +
                        " : " +
                        _vm._s(_vm.channel.name)
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("whatsappChannel.deleteChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "channel-content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("ChannelMenu", {
                    model: {
                      value: _vm.currentTab,
                      callback: function ($$v) {
                        _vm.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "page-content" }, [
                _vm.currentTab === _vm.MetaLeadsMenuTypes.CHANNEL.id
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MetaLeadsMenuTypes.VISIBILITY.id
                  ? _c(
                      "div",
                      [
                        _c("Visibility", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MetaLeadsMenuTypes.LEADS.id &&
                _vm.channel
                  ? _c(
                      "div",
                      [
                        _c("LeadList", {
                          attrs: {
                            channel: _vm.channel,
                            "channel-id": _vm.channel._id,
                            "form-mode": !!_vm.selectedFormId,
                            "form-id": _vm.selectedFormId,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === _vm.MetaLeadsMenuTypes.FORMS.id &&
                _vm.channel
                  ? _c(
                      "div",
                      [
                        _c("FormList", {
                          attrs: {
                            channel: _vm.channel,
                            "channel-id": _vm.channel._id,
                          },
                          on: {
                            showFormLeads: function (form) {
                              return _vm.showFormLeads(form)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("instagram.channel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteMetaLeadChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("whatsappChannel.deleteChannel")))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }